import Description from './description'

Description.install = vue => vue.component(Description.name, Description)

export default Description
